export default class ObjectHelper {
    static set(obj, path, value) {
        if (!obj || typeof obj !== 'object') {
            throw new Error('The first argument must be an object');
        }

        const keys = Array.isArray(path) ? path : path.split('.');

        let current = obj;

        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];

            // If it's the last key, set the value
            if (i === keys.length - 1) {
                current[key] = value;
            } else {
                // If the next level doesn't exist, create an object or array
                if (!current[key] || typeof current[key] !== 'object') {
                    current[key] = isNaN(Number(keys[i + 1])) ? {} : [];
                }
                current = current[key];
            }
        }

        return obj;
    }

    static get(obj, path, defaultValue) {
        if (!obj || typeof obj !== 'object') {
            return defaultValue;
        }

        const keys = Array.isArray(path) ? path : path.split('.');

        let current = obj;

        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];

            // Check if the key exists in the current object
            if (current && Object.prototype.hasOwnProperty.call(current, key)) {
                current = current[key];
            } else {
                return defaultValue;
            }
        }

        return current;
    }
}